var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_logo"},[_vm._v(" Окей Город ")])}
var staticRenderFns = []

export { render, staticRenderFns }